export default __webpack_public_path__ + "static/media/marble-grey.178b96e6.jpg";